import React, { Component } from "react";
import { Form, Checkbox, TimePicker, Input } from "antd";
import { isMoment } from "moment";
import { InputNumber } from "../../../../../components/common/input-number";
import { Dropdown } from "../../../../../components/common/dropdown";

const { RangePicker } = TimePicker;

export class RentalConditions extends Component {
  state = {
    include_empty_km: true,
    working_day_types: [],
    fuel_types: [],
    isflexibleWorkingDay: false,
    return_vehicle_early: true,
  };

  handleChangeEmptyKmCalc = (include_empty_km) => {
    this.setState({ include_empty_km });
  };

  onSelectDayCode = (data) => {
    const { onChangeForm } = this.props;
    if (data.id === 6) {
      this.setState({ isflexibleWorkingDay: true });
      onChangeForm("working_day_value", 1);
    } else {
      //working_day_value
      onChangeForm("working_day_value", "");
      this.setState({ isflexibleWorkingDay: false });
    }
    onChangeForm("working_day_code", data.code);
  };

  onSelectFuelType = (data) => {
    const { onChangeForm } = this.props;
    onChangeForm("fuel_type_code", data.code);
  };

  onChangeVehicleReturn = (return_vehicle_early) => {
    this.setState({ return_vehicle_early }, () => {
      const { editPage, checkChangeFormValue } = this.props;
      if (editPage) {
        checkChangeFormValue();
      }
    });
  };

  render() {
    const {
      include_empty_km,
      working_day_types,
      isflexibleWorkingDay,
      fuel_types,
      return_vehicle_early,
    } = this.state;
    const { unlimitEdit, limitEdit, isEdit, isOwner, typeOption } = this.props;
    return (
      <>
        <div className="title-contract">10. Điều kiện thuê*</div>
        <Form.Item
          wrapperCol={15}
          name={"OLQ001"}
          label={`+ Định mức km::`}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập định mức km!`,
            },
          ]}
        >
          <InputNumber disabled={!limitEdit} suffix={"Km/tháng"} />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Tính số km rỗng:</div>
            </div>
          }
          className="lableEmptyKm"
        >
          <div style={{ flexDirection: "column" }} className="vat-fee">
            <Checkbox
              disabled={!isEdit}
              onChange={() => this.handleChangeEmptyKmCalc(true)}
              checked={include_empty_km}
            >
              Có tính số km rỗng
            </Checkbox>
            <Checkbox
              disabled={!isEdit}
              onChange={() => this.handleChangeEmptyKmCalc(false)}
              checked={!include_empty_km}
            >
              Không tính số km rỗng
            </Checkbox>
          </div>
        </Form.Item>
        <Form.Item
          name={"works_time"}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Thời gian làm việc:</div>
            </div>
          }
          rules={[
            // {
            //   required: true,
            //   message: `Vui lòng nhập thời gian làm việc!`,
            // },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || value.length < 2) {
                  return Promise.reject("Vui lòng nhập thời gian làm việc!");
                }
                if (
                  value &&
                  value.length === 2 &&
                  isMoment(value[0]) &&
                  isMoment(value[1])
                ) {
                  const startUnix = value[0].unix();
                  const endUnix = value[1].unix();
                  if (endUnix - startUnix >= 14400) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "Thời gian kết thúc lớn hơn 4 giờ so với bắt đầu"
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <RangePicker
            disabled={!limitEdit}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            style={{ width: "100%" }}
            format="HH:mm"
          />
        </Form.Item>
        <Form.Item
          className="working-day"
          name={"working_day_code"}
          label={`+ Ngày làm việc::`}
          rules={[
            {
              required: true,
              message: `Vui lòng chọn ngày làm việc!`,
            },
          ]}
        >
          <Dropdown
            disabled={!limitEdit}
            select={this.onSelectDayCode}
            className="dropdown-full"
            title="Chọn ngày làm việc"
            menu={working_day_types}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"working_day_value"}
          label={`+ Linh hoạt::`}
          rules={[
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!isflexibleWorkingDay) {
                  return Promise.resolve();
                }
                if (value !== null && value !== undefined) {
                  if (Number(value) >= 1 && Number(value) <= 31) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "Ngày làm việc phải thuộc khoảng 1 đến 31 ngày"
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          {!isflexibleWorkingDay ? (
            <Input
              disabled={!isflexibleWorkingDay || !limitEdit}
              suffix={"ngày"}
            />
          ) : (
            <InputNumber
              disabled={!isflexibleWorkingDay || !limitEdit}
              suffix={"ngày"}
            />
          )}
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"OLQ005"}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Định mức nhiên liệu:</div>
            </div>
          }
          rules={[
            {
              required: true,
              message: `Vui lòng nhập định mức nhiên liệu!`,
            },
          ]}
        >
          <InputNumber percent disabled={!limitEdit} suffix={"lít/100km"} />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>% điều chỉnh của nhiên liệu:</div>
            </div>
          }
          name={"fuel_adjust_percent"}
          rules={[
            {
              pattern: /^100$|^[0-9]{1,2}$|^[0-9]{1,2}\.[0-9]{1,100}$/,
              message: `Vui lòng nhập giá trị trong trong khoảng 0-100!`,
            },
          ]}
        >
          <InputNumber percent disabled={!limitEdit} max={100} suffix={"%"} />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Trả xe trước hạn HĐ:</div>
            </div>
          }
        >
          <div className="vat-fee">
            <Checkbox
              disabled={!unlimitEdit}
              onChange={() => this.onChangeVehicleReturn(1)}
              checked={return_vehicle_early}
            >
              Có
            </Checkbox>
            <Checkbox
              disabled={!unlimitEdit}
              onChange={() => this.onChangeVehicleReturn(0)}
              checked={!return_vehicle_early}
            >
              Không
            </Checkbox>
          </div>
        </Form.Item>
        <Form.Item
          className="working-day"
          name={"fuel_type_code"}
          label={`+ Loại nhiên liệu::`}
          rules={[
            {
              required: true,
              message: `Vui lòng chọn loại nhiên liệu!`,
            },
          ]}
        >
          <Dropdown
            disabled={!unlimitEdit}
            select={this.onSelectFuelType}
            className="dropdown-full"
            title="Chọn loại nhiên liệu"
            menu={fuel_types}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"CT020"}
          label={`+ Giá nhiên liệu hiện tại::`}
        >
          <InputNumber
            className={
              !isOwner && typeOption !== "create_new" ? "hidePrice" : ""
            }
            is_money
            disabled={!limitEdit || (typeOption !== "create_new" && !isOwner)}
            suffix={"VNĐ/lít"}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          label={
            <div className="label-special">
              <div className="plus">+</div>
              <div>Trả xe báo trước:</div>
            </div>
          }
          name={"days_inform_before_return_vehicle"}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập số ngày báo trước!`,
            },
          ]}
        >
          <InputNumber disabled={!unlimitEdit} suffix={"ngày"} />
        </Form.Item>
      </>
    );
  }
}
